import {Box} from '@esgi/ui/layout';
import {styled} from '@esgi/ui/theme';

export const BodyBox = styled(Box, {
	paddingTop: '$4',
	paddingBottom: '$6',
	background: 'linear-gradient(126deg, #F0F0F0 0.11%, #EBEBEB 71.15%)',
});
